import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import GridOption from '../GridOption/GridOption';
const GridOptions = ({ className, variant, options }) => {
    const { GridOptions: css } = useTheme('Entities').FareGroupV2;
    return (React.createElement("div", { className: cn(css.root, className, css[variant]) }, options.map((option, index) => (React.createElement(GridOption, Object.assign({ key: index, className: css.option, variant: variant }, option))))));
};
export default GridOptions;
